import { useState } from "react";

// material ui components
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";

// libraries
import classNames from "classnames";

// styles
import styles from "./styles.module.css";
import { SelectedTab } from "../userProfile";
import { PROFILE_LIST } from "./constant";
import { Typography } from "@mui/material";

interface Props {
  handleSelection: (selected: SelectedTab) => void;
  selectedTab: SelectedTab;
}

const ProfileList = ({ handleSelection, selectedTab }: Props): JSX.Element => {
  const [showMenu, setShowMenu] = useState(false);
  const ListData = [
    { tab: SelectedTab.PROFILE_TAB, text: PROFILE_LIST.PERSONAL_DATA },
    { tab: SelectedTab.ADDRESS_TAB, text: PROFILE_LIST.ADDRESS },
    { tab: SelectedTab.SECURITY_TAB, text: PROFILE_LIST.SECURITY_CODE },
    { tab: SelectedTab.PAYMENT_TAB, text: PROFILE_LIST.MEANS_OF_RECEIVING },
  ];

  const List = () => {
    return (
      <Box>
        <Box className={styles["list"]}>
          {ListData?.map((item, index) => (
            <>
              <ListItem
                className={classNames(
                  selectedTab === item?.tab
                    ? styles["list_item_active"]
                    : styles["list_item"]
                )}
                button
                onClick={() => {
                  setShowMenu(false);
                  handleSelection(item?.tab);
                }}>
                <ListItem>
                  <ListItemText>{item?.text}</ListItemText>
                </ListItem>
              </ListItem>
              {index < ListData?.length - 1 && (
                <div className={styles["divider"]} />
              )}
            </>
          ))}
        </Box>
      </Box>
    );
  };

  return (
    <div>
      <Box
        onClick={() => setShowMenu(!showMenu)}
        className={styles["setting_button"]}>
        <Box
          className={styles["setting_img"]}
          component="img"
          src="/assets/images/svg/menu.svg"
        />
        <Typography variant="body1">{PROFILE_LIST.SETTINGS}</Typography>
      </Box>
      <Box
        className={classNames(
          showMenu ? styles["dropdown"] : styles["dropdown-hide"]
        )}>
        {List()}
      </Box>
      <Box className={styles["container"]}>{List()}</Box>
    </div>
  );
};

export default ProfileList;
